/**
 * Parse reedle:flashcard code block content
 *
 * Format:
 * ```reedle:flashcard
 * front: Question or prompt text
 * ---
 * Answer content (supports markdown)
 * ```
 *
 * @param {string} content - Raw content from code block
 * @returns {{ front: string, back: string }}
 */
export function parseFlashcardContent(content) {
  if (!content || typeof content !== 'string') {
    return { front: '', back: '' };
  }

  const lines = content.split('\n');
  let front = '';
  let bodyStart = 0;
  let foundSeparator = false;

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i].trim();

    if (line.startsWith('front:')) {
      front = line.substring(6).trim();
    } else if (line === '---') {
      bodyStart = i + 1;
      foundSeparator = true;
      break;
    }
  }

  // If no separator found, use entire content as back
  if (!foundSeparator) {
    // If we found a front but no separator, use remaining as back
    if (front) {
      const frontLineIndex = lines.findIndex(l => l.trim().startsWith('front:'));
      bodyStart = frontLineIndex + 1;
    } else {
      // No front, no separator - use first line as front, rest as back
      front = lines[0]?.trim() || '';
      bodyStart = 1;
    }
  }

  const back = lines.slice(bodyStart).join('\n').trim();

  return { front, back };
}

/**
 * Validate if a parsed card has required content
 * @param {{ front: string, back: string }} card
 * @returns {boolean}
 */
export function isValidFlashcard(card) {
  return Boolean(card.front && card.back);
}
